import { render, staticRenderFns } from "./AuditFailureByResponsibilityGroupDrillDown.vue?vue&type=template&id=b676847c&"
import script from "./AuditFailureByResponsibilityGroupDrillDown.vue?vue&type=script&lang=ts&"
export * from "./AuditFailureByResponsibilityGroupDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports